import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Typography, units } from '@hbf/dsl';
import { UserEntity } from 'ha/types/UserEntity';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Link } from 'ha/ui.legacy/Link';

const useStyles = makeStyles()(() => ({
  link: {
    display: 'grid',
    textDecoration: 'none',
  },
  nameLabel: {
    marginBottom: units.rem(0.2),
  },
}));

interface Props {
  user: UserEntity;
  linkToProfile?: boolean;
}

const UserCardProfileName: React.FC<Props> = ({ user, linkToProfile }) => {
  const { urlResolver } = useIntl();
  const { classes } = useStyles();

  const profileName = (
    <Typography.H3 overflow="ellipsis" className={classes.nameLabel}>
      {user.firstName}
    </Typography.H3>
  );

  if (!linkToProfile) {
    return profileName;
  }

  return (
    <Track name="Clicked Advertiser name" type="link">
      <Link
        to={urlResolver.getLinkToUserPage(user.entityId)}
        target="_blank"
        className={classes.link}
        title="Profile preview"
        data-test-locator="User Card Name"
        skipLangFormat
        noFollow
      >
        {profileName}
      </Link>
    </Track>
  );
};

export { UserCardProfileName };
